export default __webpack_public_path__ + "static/media/Private_Equity_20221202.b3d02901.pdf";